<template>
    <transition name="HotspotEntrance" v-on:after-enter="setHotspotWidth" >
    <div v-show="ready" class="Hotspot btnfx"
        @mouseover="mouseOver = true" @mouseleave="mouseOver = false">
        <div class="Hotspot__button btnfx__clickflash"></div>
        <span v-html="hotspot.name" ref="hotspotLabel" :style="showLabelAnimation"></span>
    </div>
</transition>

</template>

<script>

export default {
    props: ['hotspot'],
    data() {
        return {
            ready: false,
            mouseOver: false,
            offsetWidth: 0
        }
    },
    created(){
        setTimeout(() => {
                this.ready = true;
            }, 200);
    },
    methods: {
       
        hotspotPressed() {
            this.$emit('hotspotPressed', this.hotspot)
        },
        setHotspotWidth() {
            if (!this.$refs.hotspotLabel)
                return

            this.offsetWidth = this.$refs.hotspotLabel.offsetWidth;
        }
    },
    computed: {
        getPosition() {
            return {
                left: this.hotspot.data.positionData.xPosition + 'px',
                top: this.hotspot.data.positionData.yPosition + 'px'
            }
        },
               
        showLabel() {
            return this.showLabelsGlobally || (!this.showLabelsGlobally && this.mouseOver)
        },
        showLabelsGlobally() {
            return this.$store.getters.isHotspotLabelsVisible
        },

        showLabelAnimation() {
            
            if (this.hotspot.flipped) {
                return {
                    'margin-right': this.showLabel ? '' : `-${this.offsetWidth}px`
                }
            } else {
                return {
                    'margin-left': this.showLabel ? '' : `-${this.offsetWidth}px`
                }
            }
        }
    }
}
</script>


<style lang="scss">
$hotspot-height: 40px;

.Hotspot {

  

    .Hotspot__button {
        
    }

    span {
      
    }

}
</style>